import { Component } from 'react';
import './App.css'
import Image from "react-graceful-image";

import artwork from './images/ceiling-waves-vinyl.png'
import ceiling_waves_handwritten from './images/ceiling-waves-handwritten.svg'

class CeilingWavesSmartLinks extends Component {
	render() {
		return (
			<div className="Smart-links">
				<div>
					<a href="https://sheepdogwolf.bandcamp.com/album/ceiling-waves"><Image src={artwork} noLazyLoad="true" placeholderColor="#000" className="Smart-link-single-artwork" /></a>
					<br></br>
					<div className="Mobile-only">
						<div className="Small-smart-links-text">listen to the new album</div>
						<img className="Smart-links-handwritten-text" src={ceiling_waves_handwritten}></img>
					</div>
					<div className="Desktop-only">
						<div className="Smart-link-buttons">
							<a href="https://sheepdogwolf.bandcamp.com/album/ceiling-waves"><btn className="Smart-link-button">buy ltd. edition vinyl</btn></a>
						</div>
					</div>
				</div>
				<div className="Smart-link-buttons">
					<div className="Desktop-only">
						<div className="Small-smart-links-text">listen to the new album</div>
						<img className="Smart-links-handwritten-text" src={ceiling_waves_handwritten}></img>
					</div>
					<div className="Mobile-only">
							<a href="https://sheepdogwolf.bandcamp.com/album/ceiling-waves"><btn className="Smart-link-button">buy ltd. edition vinyl</btn></a>
					</div>
					<a href="https://sheepdogwolf.bandcamp.com/album/ceiling-waves"><btn className="Smart-link-button">bandcamp</btn></a>
					<a href="https://tidal.com/album/511909482"><btn className="Smart-link-button">tidal</btn></a>
					<a href="https://link.deezer.com/s/342r73Cw5s8cLzKpvBBTL"><btn className="Smart-link-button">deezer</btn></a>
					<a href="https://music.apple.com/album/ceiling-waves/1889913381"><btn className="Smart-link-button">apple music</btn></a>
					<a href="https://open.spotify.com/album/2MCvbytdp0Bl87Yc3hyvKG?si=a400c92c1af74dc7"><btn className="Smart-link-button">spotify</btn></a>
					<div className="Spotify-notice">
					IF YOU ARE A SPOTIFY USER, PLEASE CONSIDER USING ANOTHER STREAMING SERVICE. <a href="https://www.cnbc.com/2025/06/17/spotifys-daniel-ek-leads-investment-in-defense-startup-helsing.html">THEIR CEO HEAVILY INVESTS IN AI WEAPONS TECH</a>. I DONATE MY SPOTIFY PROFITS TO MEDICAL AID FOR PALESTINIANS.
				</div>
				</div>
			</div>
		);
	}
}

export default CeilingWavesSmartLinks;